import {GenericService} from '@/shared/xhttp';
import {Proprietaire} from '@/models';

export class ProprietaireService extends GenericService<Proprietaire> {
}
